module.exports = __webpack_public_path__ + "img/tip@3x.686be709.png";